import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import MethodGet from "../../../../src/Config/Services";
const SelectState = (props) => {
  const [states, saveStates] = useState([]);
  useEffect(() => {
    let url = "/states";
    MethodGet(url)
      .then((res) => {
        saveStates(res.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
  };
  const detectarCambiosState = (value) => {
    props.detectarCambiosState(value);
  };
  return (
    <>
      <Select
        label="Selecciona un Estado"
        autofocus
        placeholder="Selecciona un Estado"
        options={states.map((state) => {
          let attribute = {
            label: state.name,
            value: state.id,
          };
          return attribute;
        })}
        styles={selectStyles}
        onChange={(value) => detectarCambiosState(value)}
      />
    </>
  );
};

export default SelectState;
